import { z } from 'zod'

// Проект — сущность хаба (справочник GET /api/projects). companyId держит
// иерархию: проект без компании невозможен — инвариант хаба, который зеркалит
// форма привязки звонка.
export const ProjectSchema = z.object({
  id: z.string(),
  companyId: z.string(),
  name: z.string(),
  slug: z.string().optional(),
})

export type Project = z.infer<typeof ProjectSchema>
